<div>
	@for (imageCategory of imageCategories(); track imageCategory.title; let first = $first) {
	<lib-card [isForm]="true" [title]="imageCategory.title" [class.push-top-md]="!first">
		<ui-file-form-field
			[validation]="'images'"
			[imageCrop]="imageGalleryCrop"
			[isRequired]="false"
			[uploadFunction]="getUploadFunction(imageCategory.images)"
			[valueAsSignal]="imageCategory.images"
			(valueChange)="handleUploadImage($event, imageCategory.images)"
			[isInDialog]="isInDialog()"
		></ui-file-form-field>
	</lib-card>
	}

	<lib-card [isForm]="true" [title]="'Actions'" class="push-top-md">
		<ui-form-save-button
			[title]="'Save'"
			[saveHandler]="saveHandler()"
			[logHandler]="formLogHandler()"
		></ui-form-save-button>
	</lib-card>
</div>
